import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { colors, fontWeights } from '../theme';
import { HomeScreen } from '../screens/HomeScreen';
import { BookingScreen } from '../screens/BookingScreen';
import { ConfirmationScreen } from '../screens/ConfirmationScreen';

export type RootStackParamList = {
  Home: undefined;
  Booking: { serviceId?: string };
  Confirmation: {
    confirmationCode: string;
    serviceId: string;
    date: string;
    time: string;
    customerName: string;
    vehicle: string;
  };
};

const Stack = createStackNavigator<RootStackParamList>();

export function AppNavigator() {
  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerStyle: {
            backgroundColor: colors.surface,
            shadowColor: colors.border,
            shadowOpacity: 1,
            shadowRadius: 0,
            shadowOffset: { width: 0, height: 1 },
            elevation: 1,
          },
          headerTintColor: colors.accent,
          headerTitleStyle: {
            fontWeight: fontWeights.semibold,
            color: colors.textPrimary,
            fontSize: 17,
          },
          headerBackTitleVisible: false,
          cardStyle: { backgroundColor: colors.background },
        }}
      >
        <Stack.Screen
          name="Home"
          component={HomeScreen}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name="Booking"
          component={BookingScreen}
          options={{ title: 'Book an Appointment' }}
        />
        <Stack.Screen
          name="Confirmation"
          component={ConfirmationScreen}
          options={{ headerShown: false }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
}
